// 这是英文语言对象

export default {
  index: 'Home',
  allContent: 'All Content',
  more: 'More',
  search: 'Search',
  searchHistory: 'Search History',
  hotSearchRanking: 'Trending Searches',
  login: 'Log In',
  register: 'Register',
  myLikes: 'My Likes',
  myCollections: 'My Favorites',
  browsingHistory: 'History',
  myWallet: 'My Wallet',
  mySupport: 'My Support',
  selectLanguage: 'Language',
  darkMode: 'Dark Mode',
  settings: 'Settings',
  logout: 'Log Out',
  afterLoginYouCan: 'After logging in, you can',
  collectFavoriteWorks: 'Bookmark works you love',
  joinDiscussions: 'Join interactive discussions',
  viewBrowsingHistory: 'Check browsing history',
  loginNow: 'Log In Now',
  firstTimeHere: 'First time here? ',
  clickToRegister: 'Sign Up',
  externalLink: 'External Link',
  pleaseEnterEmail: 'Please enter your email address',
  pleaseEnterPassword: 'Please enter your password',
  forgotPassword: 'Forgot Password',
  readAndAgree: 'I have read and agree to ',
  userAgreementWithBracket: '《User Agreement》',
  privacyPolicyWithBracket: '《Privacy Policy》',
  and: ' and ',
  copyright: 'Slash99 ©️2025 All Rights Reserved',
  aboutUs: 'About Us',
  userAgreement: 'User Agreement',
  privacyPolicy: 'Privacy Policy',
  passwordErrorRetry: 'Incorrect password, please try again',
  passwordErrorRemaining: 'Incorrect password, {count} attempts remaining',
  accountLockedHint: 'Account temporarily locked. Please try again in 30 minutes or reset password via email',
  passwordFormatError: 'Invalid password format. Must be 8-20 characters with letters and numbers',
  pleaseAgreeAgreement: 'Please agree to the User Agreement first',
  pleaseEnterValidEmail: 'Please enter a valid email address',
  loading: 'Loading...',
  loginFailedCheckAccount: 'Login failed, please check your email and password',
  loginFailedServerDataError: 'Login failed: abnormal server response',
  loginSuccess: 'Login successful',
  userBanned: 'User account has been banned',
  emailNotVerified: 'Email not verified. Please verify your email before logging in',
  tip: 'Notice',
  confirmClearSearchHistory: 'Are you sure you want to clear search history?',
  operationSuccess: 'Operation successful',
  changePassword: 'Change Password',
  setNewPasswordHint: 'Set a new password to secure your account',
  passwordRulePlaceholder: '8-20 chars, with letters & numbers',
  pleaseEnterPasswordAgain: 'Please enter password again',
  enterVerificationCode: 'Enter verification code',
  resendAfterSeconds: 's to resend',
  sendVerificationCode: 'Send Code',
  emailFormatError: 'Invalid email address',
  passwordRuleDetail: 'Password must be 8-20 chars, including letters and numbers',
  passwordMismatch: 'Passwords do not match',
  unableToGetEmail: 'Unable to get user email',
  sending: 'Sending...',
  codeSentSuccess: 'Verification code sent',
  sendCodeFailed: 'Failed to send verification code',
  sendCodeFailedRetry: 'Failed to send code, please try again later',
  verificationCodeLengthError: 'Verification code must be 4 digits',
  submitting: 'Updating...',
  passwordResetSuccess: 'Password reset successful, please log in with your new password',
  passwordChangeFailed: 'Failed to change password',
  passwordChangeFailedRetry: 'Failed to change password, please try again later',
  featureUnderDevelopment: 'Feature under development',
  nextStep: 'Next',
  seconds: 's',
  codeSentToEmail: 'Verification code sent to\nyour email',
  verifying: 'Verifying...',
  verificationCodeError: 'Incorrect verification code',
  codeSentToYourEmail: 'Verification code sent to your email',
  emailAlreadyRegistered: 'This email is already registered',
  pleaseSendVerificationCodeFirst: 'Please click send verification code first',
  registering: 'Registering...',
  registerSuccess: 'Registration successful',
  registerFailedRetry: 'Registration failed, please try again later',
  notSetYet: 'Not set yet',
  confirmLogout: 'Confirm Logout',
  confirmLogoutMessage: 'Are you sure you want to log out?',
  cancel: 'Cancel',
  accountSettings: 'Account Settings',
  editProfile: 'Edit Profile',
  redeemCode: 'Redeem Code',
  deleteAccount: 'Delete Account',
  legalInfo: 'Legal Information',
  noContent: 'No content',
  paymentIconLoadFailed: 'Failed to load payment icons',
  footerCopyright: '© 2025-2026 slash99.com. All rights reserved.',
  // 个人资料编辑
  changeAvatar: 'Change Avatar',
  account: 'Account',
  nickname: 'Nickname',
  pleaseEnterNickname: 'Please enter nickname',
  gender: 'Gender',
  save: 'Save',
  selectGender: 'Select Gender',
  male: 'Male',
  female: 'Female',
  secret: 'Confidential',
  uploading: 'Uploading...',
  uploadFailed: 'Upload failed',
  uploadFailedRetry: 'Upload failed, please try again later',
  chooseImageFailed: 'Failed to choose image',
  updateAvatarError: 'Avatar update error',
  updateNicknameError: 'Nickname update error',
  avatarUploadingPleaseWait: 'Avatar is uploading, please wait',
  nicknameFormatError: 'Nickname only supports Chinese, English, and numbers',
  nicknameLengthError: 'Nickname up to 10 Chinese characters or 20 English characters',
  noChangesToSave: 'No changes to save',
  userIdNotExist: 'User ID does not exist',
  saving: 'Saving...',
  saveSuccess: 'Saved successfully',
  saveFailed: 'Save failed',
  saveFailedRetry: 'Save failed, please try again later',
  // 兑换码中心
  redeemCenter: 'Redeem Center',
  redeemSubtitle: 'Enter redeem code to get exclusive benefits',
  pleaseEnterRedeemCode: 'Please enter redeem code',
  paste: 'Paste',
  redeeming: 'Redeeming...',
  redeem: 'Redeem',
  redeemCodeTips: 'Redeem code is case-sensitive, do not include spaces',
  redeemRecords: 'Redeem Records',
  carrot: 'Carrot',
  redFlower: 'Red Flower',
  noRedeemRecords: 'No redemption records',
  goGetRedeemCode: 'Go get a redeem code and redeem it',
  obtained: 'Received',
  pasteFailed: 'Failed to paste',
  pleaseManuallyEnterRedeemCode: 'Please enter redeem code manually',
  redeemLimitReached: 'Too many invalid attempts. Temporarily restricted, please try again in 10 minutes',
  redeemCodeFormatError: 'Redeem code only supports letters, numbers, and underscores',
  redeemSuccess: 'Benefits have been successfully credited to your account',
  redeemFailed: 'Redemption failed',
  // 注销账户
  deleteAccountSubtitle: 'All data will be permanently deleted and cannot be recovered after deletion',
  deleteAccountRelatedMatters: 'Matters related to account deletion application:',
  deleteAccountPoint1: '1. The account is in a secure state',
  deleteAccountDesc1: 'The account is in normal use, with no risks such as theft, violation, or suspension',
  deleteAccountPoint2: '2. Account assets are settled',
  deleteAccountDesc2: 'Virtual asset resources under the account are forfeited, including but not limited to purchased works and balance',
  deleteAccountSecurityVerification: 'Account Deletion Security Verification',
  confirmDeleteAccount: 'Confirm Account Deletion',
  confirmDeleteAccountMessage: 'All data will be permanently deleted and cannot be recovered after deletion. Are you sure you want to continue?',
  confirmDelete: 'Confirm Delete',
  processing: 'Processing...',
  deleteAccountSuccess: 'Account deleted successfully',
  deleteAccountFailed: 'Account deletion failed',
  deleteAccountFailedRetry: 'Account deletion failed, please try again later',
  updatedDate: 'Update Date: ',
  loadFailed: 'Failed to load',
  // 内容与我的喜欢
  noLikesYet: 'No liked content yet',
  goDiscoverLikes: 'Go and discover content you like',
  thatsAllForNow: "That's all for now",
  today: 'Today',
  yesterday: 'Yesterday',
  earlier: 'Earlier',
  author: 'Author',
  shortStory: 'Short Story',
  novel: 'Novel',
  collection: 'Collection',
  posts: 'Posts',
  video: 'Video',
  videoFeed: 'Video Feed',
  audioFeed: 'Audio Feed',
  ongoing: 'Ongoing',
  completed: 'Completed',
  noCollectionsYet: 'No favorite collections yet',
  goDiscoverCollections: 'Go discover exciting collections',
  noFavoritedPostsYet: 'No favorite posts yet',
  goCollectPosts: 'Go collect your favorite posts',
  collectionLimitReached: 'Collection limit reached',
  noBrowsingHistoryYet: 'No browsing history yet',
  goExploreContent: 'Go explore exciting content',
  purchased: 'Purchased',
  subscribe: 'Subscribe',
  package: 'Package',
  live: 'Live',
  accompaniedDays: 'Accompanied',
  days: 'days',
  andAlso: 'and',
  daysRemainingToExpire: 'days remaining',
  view: 'View',
  expired: 'Expired',
  hasExpired: 'Expired',
  resubscribe: 'Resubscribe',
  noMore: 'No more',
  noSubscriptionHistoryYet: 'No subscription history yet~',
  noPurchaseHistoryYet: 'No purchase history yet~',
  noLiveHistoryYet: 'No live history yet~',
  noPurchasedCollectionsYet: 'No purchased collections yet~',
  copies: 'copies',
  upcoming: 'Upcoming',
  living: 'Live',
  canEnterLiveRoom: 'Enter live room',
  liveInterruptedWaiting: 'Live stream interrupted, waiting to resume',
  liveEnded: 'Live stream ended',
  ticketPurchased: 'Ticket purchased for this live stream',
  support: 'Support',
  pleaseSelectSubscriptionPackage: 'Please select a subscription package',
  purchasing: 'Purchasing...',
  purchaseSuccess: 'Purchase successful',
  purchaseFailed: 'Purchase failed',
  user: 'User',
  // My Wallet and Recharge
  transactionRecord: 'Transaction Record',
  purchaseQuantity: 'Purchase Quantity',
  quantity: 'Quantity',
  paymentMethod: 'Payment Method',
  otherPaymentMethods: 'Other Payment Methods',
  clickToSwitch: 'Click to switch',
  rechargeProblemQuestion: 'Having trouble topping up?',
  userRechargeAgreementWithBracket: '《User Recharge Agreement》',
  recharge: 'Top Up',
  rechargeSuccess: 'Top Up Successful',
  thisRecharge: 'This top-up',
  creditedToAccount: ', credited',
  carrots: 'Carrots',
  problemQuestion: 'Having issues?',
  largeRechargeAmountLabel: 'Your recharge amount is',
  confirmAmountCorrect: 'Please confirm if the amount is correct',
  noRefundAfterRecharge: 'Non-refundable once completed',
  confirm: 'Confirm',
  scanAlipayQrTip: 'Please scan QR code with Alipay',
  clickQrToLaunchAlipayTip: 'Tap QR code on mobile to launch Alipay',
  clickToRefresh: 'Click to refresh',
  qrCodeExpired: 'QR code has expired',
  paymentNotDetectedTip: 'Payment not detected, please refresh after paying',
  back: 'Back',
  paymentCompletedRefresh: 'Payment completed, refresh page',
  confirmingPaymentResult: 'Confirming payment result',
  paymentNotSuccessfulRetryOrContact: 'Payment unsuccessful, please retry or contact support',
  paymentCancelled: 'Payment cancelled',
  paymentQueryTimeout: 'Payment query timeout, please check transaction records',
  notLoggedIn: 'Not logged in',
  copySuccess: 'Copied successfully',
  max99: 'Max 99',
  orderClosed: 'Order closed',
  pleaseAgreeRechargeAgreement: 'Please agree to User Recharge Agreement first',
  pleaseSelectQuantity: 'Please select quantity',
  pleaseEnterQuantity: 'Please enter quantity',
  pleaseSelectPaymentMethod: 'Please select payment method',
  paymentMethodNotSupported: 'Current payment method is not supported',
  recharging: 'Topping up...',
  pleaseCheckPaymentInfo: 'Please check payment info',
  cardFormLoadFailed: 'Card form failed to load, please check network',
  rechargeFailed: 'Top up failed',
  rechargeFailedRetry: 'Top up failed, please try again later',
  paymentFailedRetry: 'Payment failed, please try again later',
  paymentCancelledByUser: 'Payment cancelled',
  pleaseCompleteRechargeAndInfo: 'Please complete recharge and fill in payment info',
  paymentCredentialMissing: 'Payment credential missing, please click recharge again',
  paymentFailed: 'Payment failed',
  pleaseCompletePaymentOperation: 'Please complete payment operation',
  paymentProcessing: 'Payment processing',
  contentNotExist: 'Content does not exist',
  alipay: 'Alipay',
  wechatPay: 'WeChat Pay',
  officialRechargeStore: 'Official Recharge Store',
  recent180DaysTip: 'Only records from the past 180 days are displayed',
  noTransactionRecordYet: 'No transaction records yet',
  rechargeOrConsumeTip: 'Go recharge or consume now',
  loadMore: 'Load More',
  platformGift: 'Platform Gift',
  liveIncome: 'Live Income',
  transaction: 'Transaction',
  getTransactionRecordFailed: 'Failed to get transaction records',
  loadFailedRetry: 'Loading failed, please try again',
  // Home Feed & Cookie
  recommendChrome: 'Recommended to use Chrome browser',
  happeningNow: 'Happening Now',
  creatorsFreshIdeas: 'Fresh ideas and works from creators',
  viewFullText: 'View Full Text',
  unlockNow: 'Unlock Now',
  follow: 'Follow',
  all: 'All',
  weUseCookies: 'We use cookies',
  cookieConsentDesc: 'This website uses cookies to enhance your experience, analyze usage, and deliver personalized ads. By clicking "Accept All", you consent to all cookies. You can also click "Reject All" or customize your preferences.',
  acceptAll: 'Accept All',
  reject: 'Reject',
  swipeUpToLoadMore: 'Swipe up to load more',
  shareLinkCopied: 'Share link copied',
  copyFailed: 'Copy failed',
  subscriberOnlyContent: 'This content is for subscribers only',
  unlockToViewFullContent: 'Unlock to view full content',
  subscribeToUnlockPrefix: 'Subscribe to',
  subscribeToUnlockSuffix: 'to unlock',
  minCarrotsToUnlockPrefix: 'Unlock content from',
  minCarrotsToUnlockSuffix: 'carrots',
  purchaseCollectionToUnlock: 'Purchase collection to unlock',
  cannotPlay: 'Cannot play',
  contentIncomplete: 'Content information is incomplete',
  followed: 'Followed',
  followFailed: 'Failed to follow',
  operationFailed: 'Operation failed',
  creator: 'Creator',
  roomIdNotExist: 'Room ID does not exist',
  liveStatusAbnormal: 'Live status abnormal',
  getLiveRoomInfoFailed: 'Failed to get live room info',
  networkErrorRetry: 'Network error, please try again later',
  liveReminderSet: 'Live reminder set',
  followSuccess: 'Followed successfully',
  feedChannel: 'Feed Channel',
  // Special Activity
  popularityRanking: 'Popularity Ranking',
  cpRanking: 'CP Ranking',
  sendFlowers: 'Send Flower',
  rankingDataNotExist: 'Ranking data does not exist',
  topContribution: 'Contribution TOP',
  rushToGrab: 'Hurry up and grab it',
  notConfigured: 'Not configured',
  getArticleFailed: 'Failed to get article',
  activityTopic: 'Special Activity',
  tenThousand: 'w',
  hundredMillion: '100M',
  // 个人中心 profile
  myProfile: 'Profile',
  confirmDeletePost: 'Confirm Delete',
  deletePostConfirmMessage: 'Are you sure you want to delete this content? It cannot be recovered after deletion.',
  likes: 'Likes',
  collections: 'Favorites',
  history: 'History',
  creationCenter: 'Creator Center',
  contactCustomerService: 'Contact Support',
  edit: 'Edit',
  noRelatedContentFound: 'No related content found',
  delete: 'Delete',
  creation: 'Create',
  wallet: 'Wallet',
  customerService: 'Support',
  startBroadcast: 'Go Live',
  copyEmailSuccess: 'Email copied successfully',
  openInBrowserTip: 'Please open in a desktop browser for the best experience',
  addressCopiedTip: 'Address copied\nPlease open in a desktop browser\nfor the best experience',
  addressCopied: 'Address copied',
  pleaseOpenInDesktopBrowser: 'Please open in a desktop browser',
  forBestExperience: 'for the best experience',
  articleInfoIncomplete: 'Incomplete article information',
  collectionInfoIncomplete: 'Incomplete collection information',
  pleaseLoginFirst: 'Please login first',
  operationFailedRetry: 'Operation failed, please try again later',
  postIdNotExist: 'Post ID does not exist',
  deleteSuccess: 'Deleted successfully',
  deleteFailed: 'Delete failed',
  justNow: 'Just now',
  minutesAgo: 'm ago',
  daysAgo: 'd ago',
  tomorrow: 'Tomorrow',
  daysLater: 'd later',
  // 合集导航 CollectionNavigation
  catalog: 'Catalog',
  nextChapter: 'Next Chapter',
  previousChapter: 'Previous Chapter',
  // 数量选择器 PcmQuantitySelector
  quickSelect: 'Quick Select',
  customQuantity: 'Custom Quantity',
  // 视频详情页 video-detail
  videoUnavailableOrDeleted: 'Video does not exist or has been taken down',
  backToHomeForMore: 'Back to home to explore more exciting content',
  expand: 'Expand',
  collapse: 'Collapse',
  lastEditedAt: 'Last edited at',
  actors: 'Cast',
  creationTeam: 'Creative Team',
  comments: 'Comments',
  reply: 'Reply',
  replyToPrefix: "Reply {'@'}",
  expandMoreReplies: 'Expand more replies',
  collapseReplies: 'Collapse replies',
  leaveYourThoughts: 'Leave your thoughts',
  send: 'Send',
  favorited: 'Favorited',
  favoriteCollection: 'Favorite Collection',
  nothingHere: 'Nothing here yet',
  collapseCatalog: 'Collapse Catalog',
  goodsIdCannotBeEmpty: 'Product ID cannot be empty',
  packageIdCannotBeEmpty: 'Package ID cannot be empty',
  collectionIdCannotBeEmpty: 'Collection ID cannot be empty',
  purchaseFailedRetry: 'Purchase failed, please try again later',
  purchaseFailedRetryShort: 'Purchase failed, please try again',
  nextEpisodeRequiresUnlock: 'Next episode requires unlocking',
  alreadyLastEpisode: 'Already the last episode',
  autoPlayFailed: 'Auto-play failed',
  copyLinkSuccess: 'Link copied successfully',
  article: 'Article',
  picture: 'Image',
  wordsCountUnit: 'words',
  commentSendSuccess: 'Comment posted successfully',
  // 他人主页 user-profile
  acknowledgements: 'Acknowledgements',
  alreadyHave: 'Already ',
  peopleSupported: ' supporters',
  subscribeToUser: 'Subscribe',
  subscribed: 'Subscribed',
  duringValidityPeriod: 'Within validity period',
  fansCircleContentUnlock: 'Limited time unlock for fan circle content',
  slashUser: 'Slash User',
  userInfoIncomplete: 'User information incomplete',
  cannotFollowSelf: 'Cannot follow yourself',
  unfollowed: 'Unfollowed',
  dayUnit: 'days',
  enter: 'Enter',
  // 简剧/短篇 short-story
  noCreationTeam: 'No creative team',
  goToNextStory: 'Next Story',
  noDeletePermission: 'No permission to delete',
  previewImageFailed: 'Failed to preview image',
  authorInfoIncomplete: 'Author information incomplete',
  pleaseEnterComment: 'Please enter a comment',
  commentIdCannotBeEmpty: 'Comment ID cannot be empty',
  postCommentFailed: 'Failed to post comment',
  unfavorited: 'Unfavorited',
  liked: 'Liked',
  unliked: 'Unliked',
  commentInfoIncomplete: 'Comment information incomplete',
  replyInfoIncomplete: 'Reply information incomplete',
  unfollowFailed: 'Failed to unfollow',
  alreadyLastStory: 'Already the last story',
  nextStoryNotFound: 'Next story not found',
  noMoreStories: 'No more stories',
  // 小说详情 novel-detail
  alreadyLastChapter: 'Already the last chapter',
  nextChapterRequiresUnlock: 'The next chapter requires unlock',
  jumpFailed: 'Jump failed',
  alreadyFirstChapter: 'Already the first chapter',
  favoriteSuccess: 'Saved to favorites',
  unfavoriteSuccess: 'Removed from favorites',
  collectionAlreadyFavorited: 'This collection is already favorited',
  collectionNotFavorited: 'This collection is not favorited',
  collectionIdNotExist: 'Collection ID does not exist',
  getCollectionDetailFailed: 'Failed to get collection details',
  getChapterListFailed: 'Failed to get chapter list',
  noChaptersInCollection: 'No chapters in this collection',
  // 搜索结果 search-result
  searchPlaceholder: 'Search what you want to see',
  comprehensive: 'Comprehensive',
  noRelatedContent: 'No related content found',
  tryOtherKeywords: 'Try other keywords',
  pleaseEnterSearchContent: 'Please enter search content',
  searchFailedRetry: 'Search failed, please try again later',
  searchUserFailedRetry: 'Search user failed, please try again later',
  confirmDeleteSearchHistory: 'Are you sure you want to delete search history?',
  cleared: 'Cleared',
  // 重置密码 reset-password
  currentAccountLabel: 'Current Account: ',
  pleaseGetCodeFirst: 'Please get verification code first',
  verificationExpired: 'Verification expired, please get verification code again',
  passwordChangeSuccess: 'Password changed successfully',
  modifying: 'Modifying...',
  passwordChangeFailedRetryLong: 'Failed to change password, please try again later',
  // 首页 index
  viewAll: '...View All',
  reachedTheEnd: 'Reached the end',
  likeToWatch: 'Likes to watch',
  swipeUpToPlay: 'Swipe up to play',
  swipeUpIconText: '👆 Swipe Up',
  swipeLeftRight: 'Swipe left or right',
  switchContent: 'Switch content',
  swipeIconText: '👈 Swipe 👉',
  ageVerification: 'Age Verification',
  areYou18YearsOld: 'Are you at least 18 years old?',
  adultContentWarning: 'Slash99.com contains adult content. Please confirm that you are at least 18 years old. Access by minors is restricted by local laws and regulations.',
  leave: 'Leave',
  yesIm18: 'Yes, I am 18 or older',
  loginOrRegister: 'Login / Register',
  editorChoice: "Editor's Choice",
  livePreview: 'Live Preview',
  enterLiveRoom: 'Enter Live Room',
  refreshBatch: 'Refresh',
  stayTuned: 'Stay tuned',
  loggedOut: 'Logged out',
  liveRoomInfoIncomplete: 'Live room information incomplete',
  loadUserInfoFailed: 'Failed to load user information',
  postInfoIncomplete: 'Post information incomplete',
  videoLoadFailed: 'Failed to load video',
  dataAnomaly: 'Data anomaly',
  // 分类与组件 category / components
  noRelatedContentCategory: 'No related content',
  tryAnotherCategory: 'Try another category',
  filterTags: 'Filter Tags',
  containsAnyOneTag: 'Contains any 1 tag',
  clear: 'Clear',
  confirmSelect: 'Confirm',
  modifyFilter: 'Modify Filter',
  maxThreeTags: 'You can select up to 3 tags',
  acknowledgementsList: 'Acknowledgements List',
  noSupportersYet: 'No supporters yet',
  alreadyHaveShort: 'Already',
  // 评论与支付 comments / alipay
  paymentSuccess: 'Payment successful',
  envNotSupportAutoAlipay: 'Current environment does not support launching Alipay',
  repliesCountSuffix: ' replies',
  share: 'Share',
  viewAllReplies: 'View all replies',
  footerList: {
    about: 'About',
    userAgreement: 'User Agreement',
    privacyPolicy: 'Privacy Policy',
    aboutUs: 'About Us',
    contactUs: 'Contact Us',
    feedback: 'Feedback',
    submission: 'Submit',
    otherMatters: 'Other Matters',
    returnPolicy: 'Return Policy',
    intellectualProperty: 'Intellectual Property',
    help: 'Help',
    '关于': 'About',
    '用户协议': 'User Agreement',
    '隐私政策': 'Privacy Policy',
    '关于我们': 'About Us',
    '联系我们': 'Contact Us',
    '问题反馈': 'Feedback',
    '投稿': 'Submit',
    '其他事项': 'Other Matters',
    '退换货政策': 'Return Policy',
    '知识产权': 'Intellectual Property',
    '帮助': 'Help',
  },
  userDrawer: { // Drawer navigation
    language: [
      { name: 'Simplified Chinese' },
      { name: 'Traditional Chinese' },
      { name: 'English' },
      { name: 'Russian' },
      { name: 'French' },
      { name: 'Thai' },
      { name: 'Lao' },
    ],
    contest: 'Marketing Contest',
  },
  tabbar: {
    data: {
      'tab1': 'Home',
    },
  },
  page: {
    contest: {
      applyFailed: 'Application failed'
    },
  }
,
  poorNetworkSwitchQuality: 'Poor network connection. Switching definition is recommended.',
  loadFailedPleaseRefresh: 'Failed to load. Please refresh and try again.',
  refresh: 'Refresh',
  definition: 'Quality',
  autoQuality: 'Auto',
  playbackSpeed: 'Speed',
  subtitle: 'Subtitle',
  translate: 'Translate',
  becomeSupporter: 'Become a Supporter',
  fansCircleBenefits: 'Fan Circle Benefits',
  inventoryColon: 'Inventory: ',
  month: 'Month',
  insufficientBalanceGoRecharge: 'Insufficient balance, go recharge',
  noPurchasableOptions: 'No purchasable options available',
  fansBadge: 'Fan Badge',
  officialEventsPriority: 'Priority participation in official events',
  purchaseBonus: 'Purchase Bonus',
  home: 'Home',
  my: 'My',
  listing: 'Coming Soon',
  supportCreator: 'Support Creator',
  goodsListing: 'Product coming soon',
  toUnlockContent: 'to unlock content',
  purchaseCollection: 'Buy Collection',
  quarter: 'Quarter',
  year: 'Year',
  total: 'Total',
  notContainCurrentContent: 'Excludes current content',
  price: 'Price',
  buy: 'Buy',
  noPurchasablePackages: 'No purchasable packages available',
  selectGifting: 'Select Gift',
  pleaseSelectTwoPersons: 'Please select two people',
  sendToColon: 'Send to: ',
  singlePerson: 'Solo',
  cp: 'CP',
  selectTwoPersons: 'Select two people',
  insufficientInventoryGoGet: 'Insufficient inventory, go get',
  sendOut: 'Send',
  pleaseSelectRecipient: 'Please select gift recipient',
  sendingOut: 'Sending...',
  sendFlowerSuccess: 'Sent flower successfully',
  sendFlowerFailedRetry: 'Failed to send flower, please retry',
  paramsError: 'Parameter error',
  contentDetail: 'Content Details',
  lightMode: 'Light Mode',
  // 直播间多语言 (Live stream i18n)
  onlineUsers: "Online Users",
  currentContributionRank: "Contribution Rank",
  noOnlineUsers: "No online users",
  noContributionRecord: "No contribution records yet",
  contributionTipDesc: "Liking, chatting, sharing, or sending gifts can all increase your contribution.",
  giveGift: "Send Gift",
  sendGift: "Send Gifts",
  liveInterruptedTemp: "Live temporarily interrupted",
  streamerRecoveringTip: "The streamer is trying to restore the stream, please try again later",
  purchasedBenefitsRetained: "Purchased benefits retained, no need to repurchase",
  liveInterruptedCannotBuy: "Live is temporarily interrupted, purchasing is currently unavailable",
  liveStreamAbnormal: "Live stream error",
  backToHome: "Back to Home",
  liveStreamEnded: "Live stream ended",
  liveRoomLoading: "Loading live room...",
  retry: "Retry",
  startedBroadcast: "Started",
  livingNow: "Live Now",
  chat: "Chat",
  buyAfterLiveResume: "Available for purchase after live resumes",
  chatAfterLiveResume: "Interact after live resumes",
  canChatAfterPurchase: "Danmaku enabled after purchase",
  canChatAfterPurchaseNotice: "Send danmaku after purchase",
  supportWithDanmaku: "Say something in chat~",
  exitClearScreen: "Exit Clear Screen",
  clearScreen: "Clear Screen",
  feedbackProblem: "Feedback",
  clickToPlay: "Click to Play",
  feedbackProblemTitle: "Feedback",
  describeFeedback: "Describe Issue",
  describeProblemPlaceholder: "Please describe the problem you encountered...",
  uploadScreenshot: "Upload Screenshot",
  optional: "Optional",
  add: "Add",
  submitFeedback: "Submit Feedback",
  give: "Send",
  liveNotStarted: "Live has not started yet",
  liveAbnormal: "Live stream error",
  liveInterrupted: "Live interrupted",
  playbackFailedRetry: "Playback failed, please retry manually",
  switchingQuality: "Switching quality...",
  contributionDescTitle: "Contribution Value Details",
  contributionDetailDesc: "Contribution measures your support and interaction in this live stream. Watching, chatting, sending gifts, and sharing can all increase your contribution. Different actions have different impacts, subject to actual display.",
  totalPeopleCount: "{count} total",
  userDefault: "User",
  me: "Me",
  gapToBeSurpassed: "{gap} points before being overtaken",
  gapToSurpassPrevious: "{gap} points to pass next rank",
  gapToGetRanked: "{gap} points to enter ranking",
  loginToWatchAndInteract: "Log in to watch live and interact",
  loginSlashRegister: "Log In / Register",
  startBroadcastAt: "Starts at {time}",
  hasAccessDirectWatch: "Access granted · Watch directly when live",
  unlockToWatchLiveAndChat: "Unlock to watch live stream and chat",
  saleStartBroadcastAt: "Sale · Starts at {time}",
  buyThisLiveStream: "Buy this live for {price}",
  fullscreen: "Fullscreen",
  senderSentGiftCombo: "{sender} sent {gift} ×{count}",
  comboCountText: "{count} Combos!",
  combo: "Combo",
  insufficientBalance: "Insufficient balance",
  giftBalanceModalMsg: "This gift costs {cost}, current balance {balance}.",
  goRecharge: "Recharge",
  loginToInteractNotice: "Please log in to watch, chat, send gifts, and view rankings",
  loginToViewChat: "Log in to view danmaku and interact",
  platformNotice: "Notice",
  hostAnnouncement: "Host Announcement",
  streamerNotStartedChatNotice: "Streamer hasn't started yet. Danmaku will appear here once live",
  sendFailedRetry: "Failed to send, please retry",
  loginToChatPlaceholder: "Log in to chat",
  notStartedCannotSend: "Not live yet, sending disabled",
  messagesFailedClickRetry: "{count} message(s) failed, tap to resend",
  favoriteProgramList: "Save Program List",
  stillNeed: "Need",
  sentDot: "Send · ",
  sent: "Sent",
  sessionNotExist: "Session information does not exist",
  insufficientCarrotRechargeConfirm: "Insufficient Carrots, go to recharge?",
  danmakuMax50Words: "Danmaku maximum 50 characters",
  mutedByHostCannotChat: "You have been muted by the host",
  chatServiceConnecting: "Chat service connecting, please wait",
  networkDisconnectedCheck: "Network disconnected, please check connection",
  connectionDisconnectedReconnecting: "Disconnected, reconnecting...",
  kickedOutReconnecting: "Kicked out, reconnecting...",
  insufficientCarrotsComboStopped: "Insufficient carrots, combo stopped",
  sendGiftSuccessCelebration: "🎉 Sent successfully",
  giftOffShelfComboStopped: "Gift removed, combo stopped",
  giftOffShelf: "Gift removed",
  liveInterruptedCannotGift: "Stream interrupted, cannot send gifts",
  notStartedCannotGift: "Not live yet, cannot send gifts",
  giftSendSuccess: "Gift sent successfully",
  likeFailed: "Like failed",
  linkCopied: "Link copied",
  copyFailedRetry: "Copy failed, please retry",
  shareFailedRetry: "Share failed, please retry",
  screenCleared: "Screen cleared",
  screenRestored: "Restored",
  linkCopiedOpenBrowser: "Link copied, please open in browser",
  screenshotAdded: "Screenshot added",
  feedbackSubmitSuccess: "Feedback submitted successfully",
  liveStreamCannotWatchRefresh: "Unable to watch stream temporarily, please refresh later",
  favoritedCollection: "Collection saved",
  unfavoritedCollection: "Collection unsaved",
  userEnteredLiveRoom: "joined the stream",
  userFollowedHost: "followed the host",
  userLikedHost: "liked the host ❤️",
  anonymous: "Anonymous",
  orientationCacheCleared: "Orientation cache cleared, refresh to re-detect",
  todayWithTime: "Today {time}",
  tomorrowWithTime: "Tomorrow {time}",
  dayAfterTomorrowWithTime: "In 2 days {time}",
  monthDayTime: "{month}/{day} {time}",
  postedLivePreview: "Posted a live preview",
  watchingCount: "{count} watching",
  defaultLivingTitle: "Chatting tonight with stories",
  defaultPreviewTitle: "Tomorrow: Ancient World Exploration",
  postCountUnit: "{count} posts",
  wordsCount: "{count} words",
  tenThousandWordsCount: "{count}w words",
  qualityUltra: "1080P",
  qualityHigh: "720P",
  qualityStandard: "480P",
  qualitySmooth: "360P",
  subtitleBilingual: "🌐 Chinese + English",
  subtitleEnglishOnly: "English",
  subtitleOff: "Off",
  "在线用户": "Online Users",
  "本场贡献榜": "Contribution Rank",
  "暂无在线用户": "No online users",
  "本场暂无贡献记录": "No contribution records yet",
  "点赞、发弹幕、分享或送礼，都可以增加本场贡献值。": "Liking, chatting, sharing, or sending gifts can all increase your contribution.",
  "送礼": "Send Gift",
  "送礼物": "Send Gifts",
  "直播暂时中断": "Live temporarily interrupted",
  "主播正在尝试恢复，请稍后再试": "The streamer is trying to restore the stream, please try again later",
  "已购权益保留，无需重复购买": "Purchased benefits retained, no need to repurchase",
  "直播暂时中断，当前暂不可购买": "Live is temporarily interrupted, purchasing is currently unavailable",
  "本场直播异常": "Live stream error",
  "返回首页": "Back to Home",
  "本场直播已结束": "Live stream ended",
  "直播间加载中...": "Loading live room...",
  "重试": "Retry",
  "直播中": "LIVE",
  "已开播": "Started",
  "已关注": "Following",
  "关注": "Follow",
  "正在直播": "Live Now",
  "进入": "Enter",
  "全部": "All",
  "聊天": "Chat",
  "直播恢复后可购买": "Available for purchase after live resumes",
  "直播恢复后可继续互动": "Interact after live resumes",
  "购买后可发送弹幕": "Danmaku enabled after purchase",
  "购买后即可发送弹幕": "Send danmaku after purchase",
  "弹幕支持下～": "Say something in chat~",
  "发送": "Send",
  "清晰度": "Quality",
  "退出清屏": "Exit Clear Screen",
  "清屏": "Clear Screen",
  "反馈问题": "Feedback",
  "点击播放": "Click to Play",
  "描述反馈": "Describe Issue",
  "请描述你遇到的问题...": "Please describe the problem you encountered...",
  "上传截图": "Upload Screenshot",
  "选填": "Optional",
  "添加": "Add",
  "提交中...": "Submitting...",
  "提交反馈": "Submit Feedback",
  "充值": "Recharge",
  "赠送": "Send",
  "房间ID不存在": "Room ID does not exist",
  "加载失败": "Failed to load",
  "直播尚未开始": "Live has not started yet",
  "直播异常": "Live stream error",
  "直播已中断": "Live interrupted",
  "播放失败，请手动重试": "Playback failed, please retry manually",
  "切换清晰度中...": "Switching quality...",
  "贡献值说明": "Contribution Value Details",
  "贡献值用于衡量你在本场直播中的支持与互动情况。观看直播、参与互动、赠送礼物、分享直播等行为，都可能提升你的贡献值。不同互动行为对贡献值的影响有所不同，具体以实际展示为准。": "Contribution measures your support and interaction in this live stream. Watching, chatting, sending gifts, and sharing can all increase your contribution. Different actions have different impacts, subject to actual display.",
  "共 {count} 人": "{count} total",
  "用户": "User",
  "我": "Me",
  "距被超越还差{gap}贡献值": "{gap} points before being overtaken",
  "距超越上一名还差{gap}贡献值": "{gap} points to pass next rank",
  "距有排名还差{gap}贡献值": "{gap} points to enter ranking",
  "登录后观看直播并参与互动": "Log in to watch live and interact",
  "登录 / 注册": "Log In / Register",
  "直播预告": "Live Preview",
  "{time} 开播": "Starts at {time}",
  "已获得权益·开播后可直接观看": "Access granted · Watch directly when live",
  "解锁后可观看直播画面与弹幕互动": "Unlock to watch live stream and chat",
  "售卖 · {time} 开播": "Sale · Starts at {time}",
  "{price} 购买本场": "Buy this live for {price}",
  "全屏": "Fullscreen",
  "{sender} 送出 {gift} ×{count}": "{sender} sent {gift} ×{count}",
  "{count}连击!": "{count} Combos!",
  "连击": "Combo",
  "余额不足": "Insufficient balance",
  "余额不足，去充值": "Insufficient balance, recharge now",
  "本次赠送需{cost}，当前余额{balance}。": "This gift costs {cost}, current balance {balance}.",
  "去充值": "Recharge",
  "观看直播、发弹幕、送礼物、看贡献榜需先登录": "Please log in to watch, chat, send gifts, and view rankings",
  "登录后查看弹幕、参与互动": "Log in to view danmaku and interact",
  "平台提示": "Notice",
  "主播公告": "Host Announcement",
  "主播还未开播，开播后弹幕将在此展示": "Streamer hasn't started yet. Danmaku will appear here once live",
  "发送失败，请重试": "Failed to send, please retry",
  "登录后参与聊天": "Log in to chat",
  "暂未开播，暂不可发送": "Not live yet, sending disabled",
  "{count} 条消息发送失败，点击重发": "{count} message(s) failed, tap to resend",
  "已收藏": "Saved",
  "收藏节目单": "Save Program List",
  "这里什么都没有呢": "Nothing here yet",
  "收起目录": "Collapse List",
  "还差": "Need",
  "赠送 · ": "Send · ",
  "送出": "Sent",
  "场次信息不存在": "Session information does not exist",
  "胡萝卜余额不足，是否前往充值？": "Insufficient Carrots, go to recharge?",
  "弹幕最多 50 字": "Danmaku maximum 50 characters",
  "你已被主播禁言，暂时无法发送弹幕": "You have been muted by the host",
  "聊天服务连接中，请稍后重试": "Chat service connecting, please wait",
  "网络已断开，请检查网络连接": "Network disconnected, please check connection",
  "连接已断开，正在尝试重连...": "Disconnected, reconnecting...",
  "被踢出，正在重连...": "Kicked out, reconnecting...",
  "胡萝卜不足，连击已停止": "Insufficient carrots, combo stopped",
  "🎉 赠送成功": "🎉 Sent successfully",
  "礼物已下架，连击已停止": "Gift removed, combo stopped",
  "礼物已下架": "Gift removed",
  "直播信号中断，暂时无法送礼": "Stream interrupted, cannot send gifts",
  "暂未开播，暂不可送礼": "Not live yet, cannot send gifts",
  "礼物发送成功": "Gift sent successfully",
  "点赞失败": "Like failed",
  "链接已复制": "Link copied",
  "复制失败，请重试": "Copy failed, please retry",
  "分享失败，请重试": "Share failed, please retry",
  "已清屏": "Screen cleared",
  "已恢复": "Restored",
  "链接已复制，请在浏览器中打开": "Link copied, please open in browser",
  "截图已添加": "Screenshot added",
  "反馈提交成功": "Feedback submitted successfully",
  "直播暂时无法观看，请稍后刷新试试": "Unable to watch stream temporarily, please refresh later",
  "已收藏合集": "Collection saved",
  "已取消收藏": "Collection unsaved",
  "进入了直播间": "joined the stream",
  "关注了主播": "followed the host",
  "给主播点了喜欢 ❤️": "liked the host ❤️",
  "匿名": "Anonymous",
  "已清除方向缓存，刷新后重新检测": "Orientation cache cleared, refresh to re-detect",
  "今天 {time}": "Today {time}",
  "明天 {time}": "Tomorrow {time}",
  "超清": "1080P",
  "高清": "720P",
  "标清": "480P",
  "流畅": "360P",
  sale: "Sale",
  "售卖": "Sale",
  buyThisTicket: "Buy Ticket",
  "购买本场": "Buy Ticket",
  costForGiftColon: "Cost: ",
  "本次赠送需": "Cost: ",
  currentBalanceColon: ", Balance: ",
  "，当前余额": ", Balance: ",
  period: ".",
  "。": ".",
  submitFailed: "Failed to submit",
  selectedChapterColon: "Selected: ",
  "已选择：": "Selected: ",
  kickedOut: "Kicked out",
  "被踢出": "Kicked out",
  connectionDisconnected: "Connection disconnected",
  "连接断开": "Connection disconnected",
  reconnectingNotice: "{reason}, reconnecting...",
  "{reason}，正在重连...": "{reason}, reconnecting...",
  gift: "Gift",
  "礼物": "Gift",
  "视频": "Video",
  varietyShow: "Variety",
  "综艺": "Variety",
  playback: "Playback",
  "回放": "Playback",
  ended: "Ended",
  "已结束": "Ended",
  originalQuality: "Original",
  "原画": "Original",
  "自动": "Auto",
  blurayQuality: "Blu-ray",
  "蓝光": "Blu-ray",
  standardPlusQuality: "540P",
  "标强": "540P",
  hot: "Hot",
  "热门": "Hot",
  cheap: "Cheap",
  "便宜": "Cheap",
  premium: "Premium",
  "高级": "Premium",
  "发布了直播预告": "Posted a live preview",
  "今晚陪你聊聊那些故事": "Chatting tonight with stories",
  "明日预告：千古世界探秘": "Tomorrow: Ancient World Exploration",
  "账号不能为空": "Account cannot be empty",
  "1小时内最多发送{count}次验证码，请{minutes}分钟后再试": "Maximum {count} verification codes per hour, please try again in {minutes} minutes",
  hottest: "Hottest",
  latest: "Latest",
  "最热": "Hottest",
  "最新": "Latest",
  newest: "Newest",
  pureLove: "Pure Love",
  lily: "Lily",
  ceo: "CEO",
  lady: "Lady",
  detective: "Detective",
  "月": "Month",
  "季": "Quarter",
  "年": "Year",
  "天": "days"
};
